import { gql } from '@apollo/client';

export const QUERY_CREATE_PROJECT_DROPDOWN_FIELDS = gql`
    query CreateProjectDropdownFields {
    countries {
        id
        name
        countryCode
    }
    documentsSource {
        id
        title
        type
        languageId
        copyrightNotice
    }
    languages {
        id
        name
    }
    }
`;
